import type { AvailableDaySlot } from '@brighterly/lib-core-types/options/interfaces'
import type { Page } from '@brighterly/lib-core-types/options/interfaces'

export const getFilteredByDateAvailableSlots = (date: string, slots: string[]): string[] => {
  return slots.filter(slot => slot.includes(date))
}

export const getDisabledDates = (availableDates: string[], calendarDates: string[]): string[] => {
  return calendarDates.filter(calendarDay => !availableDates.includes(calendarDay))
}

export const getAvailableSlots = (daySlots: AvailableDaySlot[]): string[] => {
  let timeSlots: string[] = []

  daySlots.forEach((daySlot) => {
    const { day } = daySlot

    const slots = daySlot.slots.map(slot => {
      return `${day} ${slot}:00`
    })

    timeSlots = [...timeSlots, ...slots]
  })

  return [
    ...new Set(timeSlots),
  ]
}

export const getAvailableDates = (daySlots: AvailableDaySlot[]): string[] => {
  return [
    ...new Set(
      daySlots.map(slot => slot.day),
    ),
  ]
}

export const getCalendarDates = (page: Page): string[] => {
  return [
    ...new Set(
      page.days.filter(day => day.inMonth).map(day => day.id),
    ),
  ]
}
